var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidityWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_15948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31051 12.3667C6.97956 12.3667 8.34514 10.9784 8.34514 9.29416C8.34514 8.41411 7.91271 7.57959 7.04784 6.87404C6.18297 6.16849 5.53052 5.12154 5.31051 4.02148C5.0905 5.12154 4.44564 6.17607 3.57318 6.87404C2.70073 7.572 2.27588 8.4217 2.27588 9.29416C2.27588 10.9784 3.64146 12.3667 5.31051 12.3667Z",
    stroke: "white",
    strokeWidth: 1.51732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52878 5.00311C10.0506 4.16943 10.4204 3.24988 10.6213 2.28711C11.0006 4.18375 12.1386 6.00453 13.6559 7.21839C15.1732 8.43224 15.9319 9.87369 15.9319 11.391C15.9362 12.4397 15.6291 13.4661 15.0494 14.34C14.4697 15.2139 13.6436 15.896 12.6758 16.2999C11.708 16.7038 10.6421 16.8112 9.61313 16.6085C8.5842 16.4058 7.63861 15.9022 6.89624 15.1615",
    stroke: "white",
    strokeWidth: 1.51732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_15948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2078,
    height: 18.2078,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityWhite);
export default __webpack_public_path__ + "static/media/humidity-white.71c01ab57f771ddbb3f03d50b14ea7fa.svg";
export { ForwardRef as ReactComponent };